// Pages written for brands, PR firms and event agencies (November 2026). The
// sitemap, the canonical filter and llms.txt read this list; the menus list
// them in src/data/service-navigation.js.
const { customProps } = require('../custom-props')
const { beautyEvents } = require('./beauty-events')
const { luggageTagsHatBar } = require('./luggage-tags-hat-bar')
const { beautyProducts } = require('./beauty-products')
const { rushLogoPrinting } = require('./rush-logo-printing')
const { productShapedTrophies } = require('./product-shaped-trophies')

const agencyPages = [
  customProps,
  beautyEvents,
  luggageTagsHatBar,
  beautyProducts,
  rushLogoPrinting,
  productShapedTrophies,
]

module.exports = {
  agencyPages,
  customProps,
  beautyEvents,
  luggageTagsHatBar,
  beautyProducts,
  rushLogoPrinting,
  productShapedTrophies,
}
